import { useContext, createContext } from 'react'

export const PlanContext = createContext({
  planName: '',
  integrationsLimit: null,
  isFreePlan: false,
  isProPlan: false,
  isEnterprisePlan: false
})

export const PlanProvider = ({ planDetails, children }) => {
  const isFreePlan = planDetails.planName === 'Free'
  const isProPlan = planDetails.planName === 'Pro'
  const isEnterprisePlan = planDetails.planName === 'Enterprise'

  return (
    <PlanContext.Provider
      value={{
        ...planDetails,
        isFreePlan,
        isProPlan,
        isEnterprisePlan
      }}
    >
      {children}
    </PlanContext.Provider>
  )
}

export const usePlanContext = () => useContext(PlanContext)
